import React, {Component} from "react";
import PopupClose from "../buttons/popup-close";
import PlayerMediaItem from "../elements/player.media.item";
import {rd} from "../../../vars/rd";

class History extends Component {
    constructor(props) {
        super(props);

        this.callback = props.callback;
        this.callbackLoaded = props.callbackLoaded;

        const [history, data] = props.data;
        /**
         * @type {{history: DaoPlayerMedia[], data: DaoPlayerData, close: boolean}}
         */
        this.state = { history, data, close: false };
    }

    componentDidMount() {
        this.mounted = true;
        if(this.callbackLoaded) this.callbackLoaded.call(null, this);
    }

    componentWillUnmount() {
        this.mounted = false;
        this.callback = null;
        this.callbackLoaded = null;
    }

    /**
     *
     * @returns {DaoPlayerMedia[]}
     */
    get history() {
        return this.state.history || [];
    }

    /**
     * @returns {DaoPlayerData}
     */
    get data() {
        return this.state.data;
    }

    /**
     * 창닫기
     */
    close(reset=false) {
        const data = reset ? [] : (this.state.data || []);
        if(this.callback) this.callback(data);
        if (this.mounted) {
            this.setState({ close: true });
        }
    }

    render() {
        return (
            <div className="popup-history">
                <h2>
                    음원 재생 기록<span>최근 재생한 {rd.playlist_limit}곡까지 표시됩니다.</span>
                    <PopupClose close={this.state.close} />
                </h2>
                <div className="popup-content">
                    <div className="history-wrap">
                        {
                            this.history.length ?
                                this.history.map((history, index) => {
                                    return (
                                        <PlayerMediaItem key={index}
                                                         data={history}
                                                         type={'recent'}
                                                         current_onair={this.data.stream.id === history.songid} />
                                    );
                                }) :
                                <div className="item empty">
                                    최근 재생한 곡이 없습니다.
                                </div>
                        }
                    </div>
                </div>

            </div>
        );
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/pages/components/popup/history.jsx